import { createSlice } from '@reduxjs/toolkit'
// import axios from 'axios'
import api, {
// TOKEN_VIDEO
} from '../../api/index'
import {
  startLoading,
  stopLoading,
} from './loadingSlice'
import {
  failed,
  success,
} from './snackSlice'
import i18n from '../../i18n'

export const courseSlice = createSlice({
  name: 'course',
  initialState: {
  },
  reducers: {
    coursesGroupFetched: (state, { payload }) => {
      state.courses = payload
    },
    professionalCoursesGroupFetched: (state, { payload }) => {
      state.professionalCourses = payload
    },
    courseGroupFetched: (state, { payload }) => {
      state.courseGroup = payload
    },
    lessonsFetched: (state, { payload }) => {
      state.lessons = payload
    },
    courseFetched: (state, { payload }) => {
      state.course = payload
    },
    courseVideosFetched: (state, { payload }) => {
      state.courseVideos = payload
    },
    courseVideoFetched: (state, { payload }) => {
      state.courseVideo = payload
    },
    videoUrlFetched: (state, { payload }) => {
      state.courseVideoUrl = payload
    },
    suggestedVideoFetched: (state, { payload }) => {
      state.suggestedVideos = payload
    },
    certificateDiscountPriceFetched: (state, { payload }) => {
      state.certificateDiscountPrice = payload
    },
    courseBasketFetched: (state, { payload }) => {
      state.courseBasket = payload
    },
    basketBasketFetched: (state, { payload }) => {
      state.basketDiscountPrice = payload
    },
    publicCoursesStatusFetched: (state, { payload }) => {
      state.publicCoursesStatus = payload
    },
    certificatesFetched: (state, { payload }) => {
      state.certificates = payload
    },
    userCertificatesFetched: (state, { payload }) => {
      state.userCertificates = payload
    },
    publicCourseDiscountFetched: (state, { payload }) => {
      state.publicCourseDiscount = payload
    },
  },
})

export default courseSlice.reducer

export const {
  coursesGroupFetched,
  professionalCoursesGroupFetched,
  courseGroupFetched,
  lessonsFetched,
  courseFetched,
  courseVideosFetched,
  courseVideoFetched,
  videoUrlFetched,
  suggestedVideoFetched,
  certificateDiscountPriceFetched,
  courseBasketFetched,
  basketBasketFetched,
  publicCoursesStatusFetched,
  certificatesFetched,
  userCertificatesFetched,
  publicCourseDiscountFetched,
} = courseSlice.actions

export const getCoursesGroup = () => (dispatch) => {
  const url = '/Course/Group?type=0'
  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      dispatch(coursesGroupFetched(res?.data?.data))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const getProfessionalCoursesGroup = () => (dispatch) => {
  const url = '/Course/Group?type=1&first=1000000'
  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      dispatch(professionalCoursesGroupFetched(res?.data?.data))
    })
    .catch((err) => {
      console.log(err)
    })
}

export const getCourseGroup = (id) => (dispatch) => {
  const url = `/Course/Group/${id}`
  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      dispatch(courseGroupFetched(res?.data?.data))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const getLessons = (params) => (dispatch) => {
  // const url = '/Course?UserId=207&CourseGroupId=6&first=100&after=0'
  const url = '/Course'
  dispatch(startLoading())

  api.get(url, { params })
    .then((res) => {
      dispatch(lessonsFetched(res?.data?.data))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const getCourse = (id) => (dispatch) => {
  const url = `/course/${id}`
  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      dispatch(courseFetched(res?.data?.data))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const getcourseVideos = (params) => (dispatch) => {
  const url = '/course/video'
  dispatch(startLoading())

  api.get(url, { params })
    .then((res) => {
      dispatch(courseVideosFetched(res?.data?.data))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const getCourseVideo = (id) => (dispatch) => {
  const url = `/course/video/${id}`
  dispatch(startLoading())

  api.get(url)
    // .then((response) => response.blob())
    .then((res) => {
      if (res?.data?.data) {
        dispatch(courseVideoFetched(res?.data?.data))
        dispatch(videoUrlFetched(res?.data?.data?.videoUrl))
      }
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const getAvailableCourseVideos = (id) => (dispatch) => {
  const url = `/course/video/${id}`
  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data?.data) {
        const videos = res?.data?.data?.filter((item) => +item?.id !== +id)

        dispatch(courseVideoFetched(videos))
        dispatch(videoUrlFetched(res?.data?.data?.videoUrl))
      }
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const sendVideoOffset = (videoId, offsetValue) => (dispatch) => {
  const url = `/course/video/${videoId}/offset/${offsetValue}`
  dispatch(startLoading())

  api.put(url)
    .then((res) => {
      console.log(res)
      // dispatch(courseVideosFetched(res?.data?.data))
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message, ''))
    })
}

export const finishVideo = (videoId) => (dispatch) => {
  const url = `/course/video/${videoId}/finish`
  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      dispatch(suggestedVideoFetched(res?.data?.data))
    })
    .catch((err) => {
      console.log(err)
    })
}

export const payCourseCertificate = (params, navigate) => (dispatch) => {
  const url = '/User/Certificate/Pay'

  dispatch(startLoading())

  api
    .post(url, params)
    .then((res) => {
      dispatch(stopLoading())

      if (res?.data?.data?.httpMethod === 1) {
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = res?.data?.data?.url
        res?.data?.data?.parameters?.forEach((param) => {
          const element = document.createElement('input')
          element.name = param?.key
          element.value = param?.value
          form.appendChild(element)
        })

        document.body.appendChild(form)
        form.submit()
      } else {
        // window.location.href = res?.data?.data?.url
        const fullUrl = res?.data?.data?.url
        const redirectUrl = fullUrl.split(window.location.host)[1]
        navigate(redirectUrl)
      }
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const checkCertificateDiscount = (code, id) => (dispatch) => {
  const url = `/User/Certificate/Check/Discount/${code}?courseGroupId=${id}`

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(certificateDiscountPriceFetched(res?.data?.data))
      }
      dispatch(success('کد تخفیف با موفقیت اعمال شد'))
      dispatch(stopLoading())
    })
    .catch((err) => {
      dispatch(failed(err?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getCourseBasket = () => (dispatch) => {
  const url = 'Course/Basket'
  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      dispatch(courseBasketFetched(res?.data?.data))
    })
    .catch((err) => {
      console.log(err)
    })
}

export const addBasket = (courseGroupId) => (dispatch) => {
  const url = `/Course/Basket/${courseGroupId}`
  dispatch(startLoading())

  // api
  //   .patch(url, data)

  api
    .patch(url)
    .then(() => {
      dispatch(success(i18n.t('addBasket_successfuly')))
      dispatch(getCourseBasket())
      // dispatch(stopLoading())
      // if (callback && typeof (callback) === 'function') callback()
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      // dispatch(stopLoading())
      return 'error'
    })
}

export const deleteCourseBasket = (data) => (dispatch) => {
  const url = 'Course/Basket'
  dispatch(startLoading())

  api({
    data,
    url,
    method: 'delete',
    headers: { 'Content-Type': 'application/json' },
  })
    .then((res) => {
      // dispatch(getCourseBasket())
      dispatch(courseBasketFetched(res?.data?.data))
      dispatch(success(i18n.t('deleteBasket_successfuly')))
    })
    .catch((err) => {
      console.log(err)
      dispatch(failed(err?.response?.data?.message ?? ''))
    })
}

export const payCourseBasket = (params, navigate) => (dispatch) => {
  const url = '/Course/Basket/Pay'

  dispatch(startLoading())

  api
    .post(url, params)
    .then((res) => {
      dispatch(stopLoading())

      if (res?.data?.data?.httpMethod === 1) {
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = res?.data?.data?.url
        res?.data?.data?.parameters?.forEach((param) => {
          const element = document.createElement('input')
          element.name = param?.key
          element.value = param?.value
          form.appendChild(element)
        })

        document.body.appendChild(form)
        form.submit()
      } else {
        // window.location.href = res?.data?.data?.url
        const fullUrl = res?.data?.data?.url
        const redirectUrl = fullUrl.split(window.location.host)[1]
        navigate(redirectUrl)
      }
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const checkBasketDiscount = (code) => (dispatch) => {
  const url = `/Course/Basket/Check/Discount/${code}`

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(basketBasketFetched(res?.data?.data))
      }
      dispatch(success('کد تخفیف با موفقیت اعمال شد'))
      dispatch(stopLoading())
    })
    .catch((err) => {
      dispatch(failed(err?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getPublicCoursesStatus = () => (dispatch) => {
  const url = '/User/Coursegroup/public/status'

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      // if (res?.data) {
      dispatch(publicCoursesStatusFetched(res?.data))
      // }

      dispatch(stopLoading())
    })
    .catch((err) => {
      dispatch(failed(err?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getAllCertificates = () => (dispatch) => {
  const url = '/User/Certificate'

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(certificatesFetched(res?.data?.data))
      }

      dispatch(stopLoading())
    })
    .catch((err) => {
      dispatch(failed(err?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const getUserCertificates = () => (dispatch) => {
  const url = '/User/Certificate'

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(userCertificatesFetched(res?.data?.data))
      }

      dispatch(stopLoading())
    })
    .catch((err) => {
      dispatch(failed(err?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const payExpirePublicCourse = (params, navigate) => (dispatch) => {
  const url = '/User/CourseGroup/Repay'

  dispatch(startLoading())

  api
    .post(url, params)
    .then((res) => {
      dispatch(stopLoading())

      if (res?.data?.data?.httpMethod === 1) {
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = res?.data?.data?.url
        res?.data?.data?.parameters?.forEach((param) => {
          const element = document.createElement('input')
          element.name = param?.key
          element.value = param?.value
          form.appendChild(element)
        })

        document.body.appendChild(form)
        form.submit()
      } else {
        // window.location.href = res?.data?.data?.url
        const fullUrl = res?.data?.data?.url
        const redirectUrl = fullUrl.split(window.location.host)[1]
        navigate(redirectUrl)
      }
    })
    .catch((e) => {
      dispatch(failed(e?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const checkEpiredPublicCourseDiscount = (code) => (dispatch) => {
  const url = `/User/Coursegroup/Check/Discount/${code}`

  dispatch(startLoading())

  api.get(url)
    .then((res) => {
      if (res?.data) {
        dispatch(publicCourseDiscountFetched(res?.data?.data))
      }
      dispatch(success('کد تخفیف با موفقیت اعمال شد'))
      dispatch(stopLoading())
    })
    .catch((err) => {
      dispatch(failed(err?.response?.data?.message ?? ''))
      dispatch(stopLoading())
    })
}

export const selectorPublicCoursesGroup = (state) => state.course.courses
export const selectorCourseGroup = (state) => state.course.courseGroup
export const selectorLessons = (state) => state.course.lessons
export const selectorCourse = (state) => state.course.course
export const selectorCourseVideos = (state) => state.course.courseVideos
export const selectorCourseVideo = (state) => state.course.courseVideo
export const selectorCourseVideoUrl = (state) => state.course.courseVideoUrl
export const selectorFinishedVideos = (state) => state.course.suggestedVideos
export const selectorDiscountPrice = (state) => state.course.certificateDiscountPrice
export const selectorProfessionalCourseGroup = (state) => state.course.professionalCourses
export const selectorCourseBasket = (state) => state.course.courseBasket
export const selectorBaskeDiscountPrice = (state) => state.course.basketDiscountPrice
export const selectorPublicCoursesStatus = (state) => state.course.publicCoursesStatus
export const selectorCertificates = (state) => state.course.certificates
export const selectorUserCertificates = (state) => state.course.userCertificates
export const selectorPublicCourseDiscount = (state) => state.course.publicCourseDiscount
